import { axios } from '../http-common';

class Member {
  domain(){
    return axios.get("v1/member/profile/domain");
  }
}

export default new Member();